<template>
    <div class="row" style="border: 1px solid #b3adad;margin-bottom: 5px;" >
        <div class="col-xs-12 order-no" style="border-bottom: 1px solid #eee;" :class="{'warning' : order.status == 'ordered','info' : order.status == 'paid','success' : order.status == 'shipped','danger' : order.status == 'canceled'}">
            <h4>Order No: {{order.id}}</h4>
        </div>
        <div class="col-xs-6" style="padding: 15px 15px;">
            <strong>Name / Address</strong>
            <p>{{order.nameaddress}}</p>

            <hr>
            <img src="/static/img/assets/ecommerce/thailandpost_logo.png" class="img-responsive" v-if="order.shippingtype == 'normal'" style="max-width: 50px">
            <img src="/static/img/assets/ecommerce/ems_logo.png" class="img-responsive" v-else-if="order.shippingtype == 'ems'" style="max-width: 50px">
            <img src="/static/img/assets/ecommerce/kerry_logo.png" class="img-responsive" v-else-if="order.shippingtype == 'kerry'" style="max-width: 50px">
        </div>
        <div class="col-xs-6" style="padding: 15px 15px;">
            <strong>Price </strong>
            <p>฿{{order.amount | decimalFormat}}</p>

            <strong>Status</strong>
            <select name="statusInput" id="statusInput" class="form-control" v-model="order.status" @change="$emit('onChangeStatus')">
                <option value="ordered">Ordered</option>
                <option value="paid">Paid</option>
                <option value="shipped">Shipped</option>
                <option value="canceled">Canceled</option>
            </select>
            <br>

            <strong>Channel</strong>
            <p>{{order.payment | capitalize}}</p>

            <div class="text-right" style="margin-top: 10px;">
                <a href="javascript:void(0);" class="btn btn-primary transparent" @click="showModal = true">View Detail</a>
            </div>
            
        </div>


        <modal-dialog v-if="showModal" @close="showModal = false">
            <span slot="header">Order Detail</span>

            <div slot="body">
                <h4>Order No: {{order.id}}</h4>
                <hr>

                <label for="product">Products</label>
                <p>
                    <editable v-model="order.productdetail" :type="'textarea'" @edited="$emit('updateOrder')"></editable>
                </p>

                <br>

                <label for="nameAndAddress">Name / Address</label>
                <p v-if="selectedBot"><a target="_BLANK" :href="'https://www.facebook.com/' + selectedBot.pageid + '/inbox/?mailbox_id=' + selectedBot.pageid +'&selected_item_id='">{{order.first_name}} {{order.last_name}}</a></p>
                <editable v-model="order.nameaddress" :type="'textarea'" @edited="$emit('updateOrder')"></editable>

                <br>
                <label for="price">Price</label>
                <editable v-model="order.amount" :filter="'decimal'" @edited="$emit('updateOrder')"></editable>

                <br>
                <label for="status">Status</label> <br>
                <select name="statusInput" class="form-control" id="statusInput" v-model="order.status" @change="$emit('onChangeStatus')">
                    <option value="ordered">Ordered</option>
                    <option value="paid">Paid</option>
                    <option value="shipped">Shipped</option>
                    <option value="canceled">Canceled</option>
                </select>

                <br>

                <label for="channel">Channel</label>
                <p>{{order.payment | capitalize}}</p>

                <br>
                <label for="tracking">Tracking</label>
                <template v-if="order.status == 'shipped'">
                <input type="text" v-model="order.trackingno" class="form-control" placeholder="Tracking No.">
                <div style="padding-top:5px;">
                    <!-- <a href="javascript:void(0);" class="btn btn-primary btn-sm" style="margin-right: 5px" @click="showPrint = true"><i class="fa fa-print"></i> Print</a> -->
                    <a href="javascript:void(0);" class="btn btn-default btn-sm" @click="$emit('updateOrder')">Send</a>
                </div> 

                    
                </template>
                <template v-else>
                    <p>{{order.trackingno ? order.trackingno : '-'}}</p>
                    
                    <!-- <div style="padding-top:5px;">
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm" style="margin-right: 5px" @click="showPrint = true"><i class="fa fa-print"></i> Print</a>
                    </div> -->
                </template>

                <br>
                <label for="shippingType">Shipping Type</label>
                <img src="/static/img/assets/ecommerce/thailandpost_logo.png" class="img-responsive" v-if="order.shippingtype == 'normal'" style="max-width: 50px">
                <img src="/static/img/assets/ecommerce/ems_logo.png" class="img-responsive" v-else-if="order.shippingtype == 'ems'" style="max-width: 50px">
                <img src="/static/img/assets/ecommerce/kerry_logo.png" class="img-responsive" v-else-if="order.shippingtype == 'kerry'" style="max-width: 50px">
                <!-- <print-cover v-model="order" v-if="showPrint" @close="showPrint = false"></print-cover> -->

                <br>
                <label>Reminder</label>
                <br>
                {{order.timestamp | moment("DD/MM/YYYY")}}<br>
                <editable v-model="order.note" :filter="'image'" :type="'image'" @edited="$emit('updateOrder')"></editable>

            </div>

            <div slot="footer">
                <a href="javascript:void(0)" class="btn btn-primary transparent" @click="showModal = false">Close</a>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import Editable from '@/components/elements/Editable'
import PrintCover from './PrintCover'
    export default {
        props: ['value'],
        data: function () {
            return {
                order: this.value,
                showPrint: false,
                showModal: false
            }
        },
        components: {
            ModalDialog,
            Editable,
            PrintCover
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot'
            }),
        },
        mounted: function(){
            if (this.$route.query.orderid && this.$route.query.orderid == this.order.id) {
                this.showModal = true
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderSummaryMobileItem.vue